// Recover live data without navigating away from the dashboard.
export const createDashboardConnectionRecovery = () => {
  let lastRequestAt = -Infinity
  let lastReconnectAt = -Infinity
  return {
    request(socket, send, now = Date.now(), force = false) {
      if (socket.readyState !== 1 || (!force && now - lastRequestAt < 10000)) return false
      lastRequestAt = now
      send()
      return true
    },
    recover(socket, lastActivityAt, now = Date.now()) {
      // The websocket library already retries disconnected sockets itself.
      if (socket.readyState !== 1 || now - lastActivityAt < 45000 || now - lastReconnectAt < 60000) return false
      lastReconnectAt = now
      socket.reconnect()
      return true
    }
  }
}
